import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Grid,
  Heading,
  Input,
  Spacer,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { FaUserCircle } from "react-icons/fa";
import { IoMdCall } from "react-icons/io";
import { MdEmail } from "react-icons/md";
import { BsFillArrowUpSquareFill } from "react-icons/bs";
import { AiFillLinkedin, AiFillGithub } from "react-icons/ai";
import { ThemeContext } from "./ThemeContext";
import { useContext, useState } from "react";
import { animateScroll as scroll } from "react-scroll";
import emailjs from "@emailjs/browser";

export default function Footer() {
  const mainTheme = useContext(ThemeContext);

  const initalState = {
    name: "",
    email: "",
    number: "",
    message: "",
  };

  const [form, setFrom] = useState(initalState);

  function handleMoveToTop() {
    scroll.scrollToTop();
  }

  function handleinput(e) {
    const { name, value } = e.target;
    setFrom({ ...form, [name]: value });
  }

  function handleSubmit() {
    const { name, email, number, message } = form;

    if (name && email && number && message) {
      if (!validateNumber(number)) {
        alert("Please enter a valid 10 digit Number.");
        return;
      }
      if (validateEmail(email)) {
        emailjs
          .send(
            process.env.REACT_APP_KEY1,
            process.env.REACT_APP_KEY2,
            form,
            process.env.REACT_APP_PUBLIC_KEY
          )
          .then(
            function (response) {
              alert("Thank you for showing interest in my profile. I'll contact you soon.");
              setFrom({
                name: "",
                email: "",
                number: "",
                message: "",
              });
              console.log("SUCCESS!", response.status, response.text);
            },
            function (err) {
              console.log("FAILED...", err);
            }
          );
      } else {
        alert("Please enter a valid email address.");
      }
    } else {
      alert("Please fill in all the required fields.");
    }
  }

  function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  function validateNumber(num) {
    const numString = num.toString();
    let count = 0;
    for (let i = 0; i < numString.length; i++) {
      if (isNaN(numString[i])) {
        return false;
      } else {
        count++;
      }
    }

    if (count === 10) {
      return true;
    }
    return false;
  }

  return (
    <Box textAlign="center" p="15px" bg={mainTheme.theme.bg} id="contact">
      <Box w="80%" margin="auto" borderTop="1.5px solid #00796B"></Box>
      {/*------- footer containter=------ */}
      <Box p="40px 20px" m="auto" textAlign="center">
        <Box>
          <Heading color="#00796B">Contact Me</Heading>
        </Box>
        <Flex flexDirection="column" alignItems="center">
          <BsFillArrowUpSquareFill
            onClick={handleMoveToTop}
            size="35px"
            color="#00796B"
          />
          <Text color="#00796B" fontWeight="bold">
            Top
          </Text>
        </Flex>
      </Box>
    </Box>
  );
}
